module.exports = __webpack_public_path__ + "media/images/Id-card-617196b0.svg";